import React from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import { getType } from 'typesafe-actions';
import {
  changePasswordInit,
  changePasswordValidationSchema,
} from './changePassword.dtos';
import { changePasswordActions } from './changePassword.actions';
import { Grid } from '@material-ui/core';

import { PasswordTextField } from '../../../common/components/fields';
import {
  ResponsiveDialog,
  ResponsiveDialogContent,
  ResponsiveDialogProps,
  ResponsiveDialogTitle,
  ResponsiveDialogText,
} from '../../../common/components/dialog';
import CancelSaveBtns from '../../../common/components/buttons/cancelSaveBtns';

const ChangePassword: React.FC<ResponsiveDialogProps> = ({ onClose, open }) => {
  const dispatch = useDispatch();

  return (
    <Formik
      initialValues={changePasswordInit}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={changePasswordValidationSchema}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        setTimeout(() => {
          setSubmitting(false);
          resetForm();
        }, 700);

        var result = dispatch({
          type: getType(changePasswordActions.request),
          payload: values,
        });

        onClose!();
      }}
      enableReinitialize={true}
    >
      {(formikProps) => {
        const {
          values,
          errors,
          isSubmitting,
          handleChange,
          handleSubmit,
        } = formikProps;
        return (
          <ResponsiveDialog open={open}>
            <form onSubmit={handleSubmit}>
              <ResponsiveDialogContent>
                <ResponsiveDialogTitle>Change password</ResponsiveDialogTitle>
                <ResponsiveDialogText>
                  Password must be 12 characters or longer with at least 1
                  uppercase letter, 1 lowercase letter, 1 number and 1 special
                  character.
                </ResponsiveDialogText>

                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <PasswordTextField
                      label='Current password'
                      fullWidth
                      name='currentPassword'
                      value={values.currentPassword}
                      onChange={handleChange}
                      error={Boolean(errors.currentPassword)}
                      helperText={errors.currentPassword}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <PasswordTextField
                      label='New password'
                      fullWidth
                      name='password'
                      value={values.password}
                      onChange={handleChange}
                      error={Boolean(errors.password)}
                      helperText={errors.password}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <PasswordTextField
                      label='Confirm password'
                      fullWidth
                      name='confirmPassword'
                      value={values.confirmPassword}
                      onChange={handleChange}
                      error={Boolean(errors.confirmPassword)}
                      helperText={errors.confirmPassword}
                    />
                  </Grid>
                </Grid>
              </ResponsiveDialogContent>

              <CancelSaveBtns
                isSubmitting={isSubmitting}
                onClose={onClose}
                saveText='change password'
                open={open}
              />
            </form>
          </ResponsiveDialog>
        );
      }}
    </Formik>
  );
};

export default ChangePassword;
